<template>
  <v-row>
    <v-col cols="12" sm="6" md="4" v-for="(task, i) in filtered_tasks" :key="i">
      <v-card
        v-bind:style="{
          background: `url(${background_image(task)})`
        }"
      >
        <v-card-text class="secondary--text">
          <v-row>
            <v-col class="font-weight-bold subtitle-1">{{
              getTaskTitle(task)
            }}</v-col>
            <v-col cols="auto" class="font-weight-light">
              {{ getTaskTime(task) }} min
            </v-col>
          </v-row>
          <v-row>
            <v-col class="text-h3 font-weight-bold">
              {{ task.count }}
            </v-col>
            <v-spacer></v-spacer>
            <v-col cols="auto">
              <v-btn @click="$emit('select', task.type)" :color="color(task)">
                {{ getTaskAction(task) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import taskTypes from "@/helpers/mixins/taskTypes";
export default {
  name: "TaskList",
  components: {},
  mixins: [taskTypes],
  data: () => ({}),
  computed: {
    color() {
      return task => {
        switch (task.type) {
          case this.$enums.taskTypes.SURVEY_TO_TAKE:
          case this.$enums.taskTypes.PULSE_TO_ANSWER:
          case this.$enums.taskTypes.FEEDBACK_TO_ACKNOWLEDGE:
            return this.$vuetify.theme.themes.light.darkaccent;
          case this.$enums.taskTypes.RESOURCE_TO_READ:
            return this.$vuetify.theme.themes.light.secondarytext;
          default:
            return this.$vuetify.theme.themes.light.performance;
        }
      };
    },
    background_image() {
      return task => {
        return this.$images.TASK_BACKGROUND.replace(
          "{color}",
          this.color(task).replace("#", "")
        );
      };
    },
    filtered_tasks() {
      let self = this;
      return this._.sortBy(this.tasks, function(o) {
        return self.getTaskSort(o);
      });
    },
    ...mapGetters({
      profile: "profile/profile",
      settings: "profile/settings",
      tasks: "task/tasks"
    })
  },
  watch: {},
  created() {},
  methods: {}
};
</script>

<style lang="scss" scoped>
.v-card {
  background-position-y: -60px !important;
  background-position-x: 115px !important;
  background-repeat: no-repeat !important;
}
</style>
